import * as globals from './globals';

//declare variables
let toggle = document.getElementById('logged-in-toggle');

//dropdown
export function dropMemberMenu() {
  let topMenu = globals.getClosest(this, '.logged-in-menu-top');
  let menu = topMenu.querySelector('.logged-in-menu');
  if (menu.classList.contains('open')) {
    menu.classList.remove('open');
    this.setAttribute('aria-expanded', 'false');
    if (globals.getClosest(this, '.utility-mobile-wrap')) {
      menu.style.overflow = "hidden";
    }
  } else {
    menu.classList.add('open');
    this.setAttribute('aria-expanded', 'true');
    if (globals.getClosest(this, '.utility-mobile-wrap')) {
      setTimeout(function() {
        menu.style.overflow = "auto";
      }, 500);
    }
  }
}

if (toggle != null || toggle != undefined) {
  toggle.addEventListener('click', dropMemberMenu);
}

//mobile handler in mobile-menu.js



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/member-dropdown.js